import { useState } from 'react'
import { cn } from '../lib/cn'
import { Button } from './ui/Button'

/** Avalia expressão simples com + − × ÷ (precedência correta, sem eval). */
function evalExpr(input: string): number | null {
  const s = input.replace(/×/g, '*').replace(/÷/g, '/')
  const tokens = s.match(/(\d+\.?\d*|[+\-*/])/g)
  if (!tokens) return null
  const out: (number | string)[] = []
  const ops: string[] = []
  const prec: Record<string, number> = { '+': 1, '-': 1, '*': 2, '/': 2 }
  for (const t of tokens) {
    if (/\d/.test(t)) out.push(parseFloat(t))
    else {
      while (ops.length && prec[ops[ops.length - 1]] >= prec[t]) out.push(ops.pop()!)
      ops.push(t)
    }
  }
  while (ops.length) out.push(ops.pop()!)
  const st: number[] = []
  for (const t of out) {
    if (typeof t === 'number') st.push(t)
    else {
      const b = st.pop() ?? 0, a = st.pop() ?? 0
      st.push(t === '+' ? a + b : t === '-' ? a - b : t === '*' ? a * b : b === 0 ? 0 : a / b)
    }
  }
  return st.length ? st[st.length - 1] : null
}

const KEYS = ['7', '8', '9', '÷', '4', '5', '6', '×', '1', '2', '3', '-', 'C', '0', '⌫', '+']

/** Calculadora em tela cheia (bottom sheet). "Inserir" devolve o resultado inteiro. */
export function Calculator({ title, initial, onInsert, onClose }: {
  title?: string
  initial?: string
  onInsert: (n: number) => void
  onClose: () => void
}) {
  const [expr, setExpr] = useState(initial && initial !== '0' ? initial : '')
  const result = evalExpr(expr)

  function press(k: string) {
    if (k === 'C') setExpr('')
    else if (k === '⌫') setExpr(e => e.slice(0, -1))
    else setExpr(e => e + k)
  }

  return (
    <div className="fixed inset-0 z-50 flex flex-col justify-end bg-black/50" onClick={onClose}>
      <div className="rounded-t-2xl bg-white p-4 pb-6" onClick={e => e.stopPropagation()}>
        {title && <p className="mb-2 text-center text-xs font-medium uppercase tracking-wide text-gray-400">{title}</p>}
        <div className="mb-3 rounded-xl bg-gray-50 px-4 py-3 text-right">
          <div className="min-h-[1.5rem] break-all font-mono text-lg text-gray-500">{expr || '0'}</div>
          <div className="font-mono text-3xl font-bold text-gray-900">= {result != null ? Math.round(result) : 0}</div>
        </div>
        <div className="grid grid-cols-4 gap-2">
          {KEYS.map(k => (
            <button key={k} type="button" onClick={() => press(k)}
              className={cn('h-14 rounded-xl text-xl font-semibold active:scale-95',
                k === 'C' || k === '⌫' ? 'bg-gray-200 text-gray-700'
                  : '÷×-+'.includes(k) ? 'bg-blue-100 text-blue-700'
                  : 'bg-gray-100 text-gray-900')}>
              {k}
            </button>
          ))}
        </div>
        <div className="mt-3 flex gap-2">
          <Button variant="secondary" size="lg" className="flex-1" onClick={onClose}>Cancelar</Button>
          <Button size="lg" className="flex-1" disabled={result == null}
            onClick={() => { if (result != null) onInsert(Math.max(0, Math.round(result))); onClose() }}>
            Inserir {result != null ? Math.max(0, Math.round(result)) : ''}
          </Button>
        </div>
      </div>
    </div>
  )
}
